import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread";

var _reducerMap;

import { handleActions } from 'redux-actions';
import actions from '../actions/checkout';
export var name = 'checkout';
var initialState = {
  availableShippingMethods: [],
  billingAddress: null,
  billingAddressError: null,
  isSubmitting: false,
  orderError: null,
  paymentMethodError: null,
  paymentCode: '',
  paymentData: null,
  receipt: {
    order: {}
  },
  shippingAddress: {},
  shippingAddressError: null,
  shippingMethod: '',
  shippingMethodError: null,
  shippingTitle: ''
};
var reducerMap = (_reducerMap = {}, _defineProperty(_reducerMap, actions.begin, function (state, _ref) {
  var payload = _ref.payload;
  return _objectSpread({}, state, payload);
}), _defineProperty(_reducerMap, actions.billingAddress.submit, function (state) {
  return _objectSpread({}, state, {
    billingAddressError: null,
    isSubmitting: true
  });
}), _defineProperty(_reducerMap, actions.billingAddress.accept, function (state, _ref2) {
  var payload = _ref2.payload;

  // Billing address can either be an object with address props OR
  // an object with a single prop, `sameAsShippingAddress`, so we need
  // to do some special handling to make sure the store reflects that.
  var newState = _objectSpread({}, state, {
    isSubmitting: false
  });

  if (payload.sameAsShippingAddress) {
    newState.billingAddress = _objectSpread({}, payload);
  } else if (!payload.sameAsShippingAddress) {
    newState.billingAddress = _objectSpread({}, payload, {
      street: _toConsumableArray(payload.street)
    });
  }

  return newState;
}), _defineProperty(_reducerMap, actions.billingAddress.reject, function (state, _ref3) {
  var payload = _ref3.payload;
  return _objectSpread({}, state, {
    billingAddressError: payload,
    isSubmitting: false
  });
}), _defineProperty(_reducerMap, actions.getShippingMethods.receive, function (state, _ref4) {
  var payload = _ref4.payload,
      error = _ref4.error;

  if (error) {
    return state;
  }

  return _objectSpread({}, state, {
    availableShippingMethods: payload.map(function (method) {
      return _objectSpread({}, method, {
        code: method.carrier_code,
        title: method.carrier_title
      });
    })
  });
}), _defineProperty(_reducerMap, actions.shippingAddress.submit, function (state) {
  return _objectSpread({}, state, {
    isSubmitting: true,
    shippingAddressError: null
  });
}), _defineProperty(_reducerMap, actions.shippingAddress.accept, function (state, _ref5) {
  var payload = _ref5.payload;
  return _objectSpread({}, state, {
    isSubmitting: false,
    shippingAddress: _objectSpread({}, state.shippingAddress, payload, {
      street: _toConsumableArray(payload.street)
    })
  });
}), _defineProperty(_reducerMap, actions.shippingAddress.reject, function (state, _ref6) {
  var payload = _ref6.payload;
  return _objectSpread({}, state, {
    isSubmitting: false,
    shippingAddressError: payload
  });
}), _defineProperty(_reducerMap, actions.paymentMethod.submit, function (state) {
  return _objectSpread({}, state, {
    isSubmitting: true,
    paymentMethodError: null
  });
}), _defineProperty(_reducerMap, actions.paymentMethod.accept, function (state, _ref7) {
  var payload = _ref7.payload;
  return _objectSpread({}, state, {
    isSubmitting: false,
    paymentCode: payload.code,
    paymentData: payload.data
  });
}), _defineProperty(_reducerMap, actions.paymentMethod.reject, function (state, _ref8) {
  var payload = _ref8.payload;
  return _objectSpread({}, state, {
    isSubmitting: false,
    paymentMethodError: payload
  });
}), _defineProperty(_reducerMap, actions.receipt.setOrder, function (state, _ref9) {
  var payload = _ref9.payload;
  return _objectSpread({}, state, {
    receipt: {
      order: payload
    }
  });
}), _defineProperty(_reducerMap, actions.receipt.reset, function (state) {
  return _objectSpread({}, state, {
    receipt: _objectSpread({}, initialState.receipt)
  });
}), _defineProperty(_reducerMap, actions.shippingMethod.submit, function (state) {
  return _objectSpread({}, state, {
    isSubmitting: true,
    shippingMethodError: null
  });
}), _defineProperty(_reducerMap, actions.shippingMethod.accept, function (state, _ref10) {
  var payload = _ref10.payload;
  return _objectSpread({}, state, {
    isSubmitting: false,
    shippingMethod: payload.carrier_code,
    shippingTitle: payload.carrier_title
  });
}), _defineProperty(_reducerMap, actions.shippingMethod.reject, function (state, _ref11) {
  var payload = _ref11.payload;
  return _objectSpread({}, state, {
    isSubmitting: false,
    shippingMethodError: payload
  });
}), _defineProperty(_reducerMap, actions.order.submit, function (state) {
  return _objectSpread({}, state, {
    isSubmitting: true,
    orderError: null
  });
}), _defineProperty(_reducerMap, actions.order.accept, function (state) {
  return _objectSpread({}, state, {
    isSubmitting: false
  });
}), _defineProperty(_reducerMap, actions.order.reject, function (state, _ref12) {
  var payload = _ref12.payload;
  return _objectSpread({}, state, {
    isSubmitting: false,
    orderError: payload
  });
}), _defineProperty(_reducerMap, actions.reset, function () {
  return initialState;
}), _reducerMap);
export default handleActions(reducerMap, initialState);